import { assets } from '@/helpers/common'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import React from 'react'

function MovingStorageSolutionBanner() {
  return (
    <>
      <section className={'hidden xl:block with-banner moving-storage-banner'}>
        <div className='main-banner'>
          <div className='container mx-auto pt-24'>
            <div className='row sm-mx:flex-col-reverse'>
              <div className='w-full text-center'>
                <LazyMotion features={domAnimation}>
                  <m.div
                    animate={{ scale: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.7 }}
                    initial={{ scale: 0.8, y: 100, opacity: 0 }}
                  >
                    <div className='banner-content text-center'>
                      <h1 className='text-4xl2 font-bold text-secondary mb-4'>Moving Storage Now Made Easy</h1>
                      <h2 className='text-2xl font-normal text-gray-400 mb-7'>
                        Move, store, and ship your luggage and boxes hassle-free with transparent prices. Ideal for
                        large to small business owners seeking reliable storage space, Ship and Storage is committed to
                        providing excellent and finest moving solutions for luggage storage, box storage, valet storage,
                        international shipping, etc. Take advantage of our affordable storage solutions today!
                      </h2>
                      <img
                        className='inline-block -mb-24'
                        src={assets('images/moving-storage/moving-storage.png')}
                        alt={''}
                      />
                    </div>
                  </m.div>
                </LazyMotion>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default MovingStorageSolutionBanner
